import { api } from './api'

const apiVersion = 'v2'

export const sheetsApi = api
    .enhanceEndpoints({
        addTagTypes: ['Sheets'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getSheets: builder.query({
                query: ({ organisationId }) => ({
                    url: `/${apiVersion}/organisation/${organisationId}/sheets`,
                }),
                transformResponse: (response) => {
                    delete response.$type

                    return response
                },
                providesTags: (result, _error, _arg) =>
                    result
                        ? [
                              { type: 'Sheets', id: 'LIST' },

                              ...(Object.keys(result)?.map((sheetId) => ({
                                  type: 'Sheets',
                                  id: sheetId,
                              })) ?? []),
                          ]
                        : [{ type: 'Sheets', id: 'LIST' }],
            }),
        }),
    })

export const { useGetSheetsQuery } = sheetsApi
